/*
	Resultado da operação
*/
export default (state, { result=undefined } = {}) => {
	state.swagger.instrucaoDePreenchimento.envio.result = result
}
	

